import {
  SEND_MONEY_NOT_FOUND,
  SEND_MONEY_CARD_NOT_FOUND,
  SEND_MONEY_FAILED,
  SEND_MONEY_INVALID_REQUEST,
  SEND_MONEY_INSUFFICIENT_BALANCE,
  SEND_MONEY_SUCCESS,
  SEND_MONEY_OPERATION_NOT_PERMITTED,
  RESET_SEND_MONEY,
  LOADING_SEND_MONEY,
} from "../types";

const initialState = {
  isLoading: false,
  notFound: false,
  failed: false,
  invalidRequest: false,
  cardNotFound: false,
  success: false,
  insufficientBalance: false,
  operationNotPermitted: false,
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SEND_MONEY:
      return {
        ...state,
        isLoading: true,
        notFound: false,
        failed: false,
        invalidRequest: false,
        cardNotFound: false,
        success: false,
        insufficientBalance: false,
        operationNotPermitted: false,
        data: {},
        status: "",
      };
    case SEND_MONEY_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        notFound: true,
        success: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false,
        insufficientBalance: false,
        operationNotPermitted: false,
        status: "This user is not registered!",
        data: action.payload,
      };

    case SEND_MONEY_INSUFFICIENT_BALANCE:
      return {
        ...state,
        isLoading: false,
        notFound: false,
        success: false,
        invalidRequest: false,
        failed: false,
        cardNotFound: false,
        insufficientBalance: true,
        operationNotPermitted: false,
        status: "Insufficient wallet balance",
        data: action.payload,
      };
    case SEND_MONEY_CARD_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        cardNotFound: true,
        success: false,
        notFound: false,
        invalidRequest: false,
        insufficientBalance: false,
        failed: false,
        operationNotPermitted: false,
        status: "Card not found!",
        data: action.payload,
      };
    case SEND_MONEY_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        notFound: false,
        success: false,
        invalidRequest: false,
        insufficientBalance: false,
        cardNotFound: false,
        operationNotPermitted: false,
        status: "Send money failed!",
        data: action.payload,
      };
    case SEND_MONEY_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        invalidRequest: true,
        failed: false,
        insufficientBalance: false,
        success: false,
        notFound: false,
        operationNotPermitted: false,
        cardNotFound: false,
        status: "Oops!, something went wrong",
        data: action.payload,
      };
    case SEND_MONEY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        notFound: false,
        invalidRequest: false,
        insufficientBalance: false,
        failed: false,
        cardNotFound: false,
        operationNotPermitted: false,
        data: action.payload,
      };
    case SEND_MONEY_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        invalidRequest: false,
        failed: false,
        insufficientBalance: false,
        success: false,
        notFound: false,
        operationNotPermitted: true,
        cardNotFound: false,
        status: "Operation Not Permitted",
        data: action.payload,
      };

    case RESET_SEND_MONEY:
      return (state = initialState);

    default:
      return state;
  }
};
